import React from "react"
import LoadingAnimation from "@kit/design/loading-animation"

function Loading() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "200px"
      }}
    >
      <LoadingAnimation />
      <p style={{ fontSize: "14px", color: "#667", marginTop: "20px" }}>
        Loading your feed...
      </p>
    </div>
  )
}

function ErrorState({ error }) {
  return (
    <div
      className="bg-gray-50"
      style={{
        border: "solid medium var(--gray-300)",
        borderRadius: "4px",
        padding: "20px",
        textAlign: "center"
      }}
    >
      <h2
        style={{ fontWeight: "bold", fontSize: "28px", marginBottom: "20px" }}
      >
        We’re unable to fetch posts
      </h2>
      <p>
        An error occurred when we tried to fetch posts from your feed. This
        issue should resolve itself in a few minutes. Alternatively, please try
        to reload the page or{" "}
        <a href="https://convertkit.com/support">contact support</a> for further
        help.
      </p>
      {process.env.NODE_ENV === "development" && (
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {error}
        </pre>
      )}
    </div>
  )
}

function EmptyState() {
  return (
    <div
      className="bg-gray-50"
      style={{
        border: "solid medium var(--gray-300)",
        borderRadius: "4px",
        padding: "20px",
        textAlign: "center"
      }}
    >
      <h2
        style={{ fontWeight: "bold", fontSize: "28px", marginBottom: "20px" }}
      >
        No posts yet
      </h2>
      <p>
        We were not able to fetch any posts from your account. You can still
        configure your feed on the right. Items will show up when you post.
      </p>
    </div>
  )
}

export function requestRenderer(currentState, props, additionalStates = {}) {
  const states = {
    loading: () => <Loading />,
    empty: () => <EmptyState />,
    failed: () => <ErrorState {...props} />,
    ...additionalStates
  }
  return states[currentState]
}
